<template>
    <div class="box">
      <a-row :gutter="24">
        <a-col :md="24">
          <a-card class="searchBox">
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-card layout="inline">
                <a-row :gutter="16">
                  <a-col :md="1" class="label">类别：</a-col>
                  <a-col
                    v-for="(item, index) in categoryTypeList"
                    :key="index"
                    :span="2" 
                  >
                    <a 
                      @click="getCategoryModelList(item.id, item.dicCode, index)" 
                      :class="{ active: activeIndex === index }" 
                      style="cursor: pointer;"
                    >
                      {{ item.dicName }}
                    </a>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :md="1" class="label">型号：</a-col>
                  <a-col
                    v-for="(item, index) in categoryModelList"
                    :key="index"
                    :span="1" 
                  >
                    <a @click="getCategoryList(item.dicName, index)" :class="{ active: activeModelIndex === index }"  style="cursor: pointer;">
                      {{ item.dicName }}
                    </a>
                  </a-col>
                </a-row>
              </a-card>
              <!-- 搜索区域 -->
          <!-- <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="商品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入商品名称" v-model="queryParam.materialName"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset()">重置</a-button>

                </a-col>
              </span>

            </a-row>

          </a-form> -->
            </div>
            <!-- 操作按钮区域 -->
            <div class="table-operator"  style="margin-top: 5px">
            </div>
  
            <!-- table区域-begin -->
            <div>
              <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="uuid"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                @change="handleTableChange">
                <span slot="action" slot-scope="text, record">
                  <template v-for="(item, index) in record.actionButtons" >
                    <a :key="index" @click="handleProcessClick(item.process, record)">{{ item.label }}123</a>
                    <a-divider v-if="index < record.actionButtons.length - 1" type="vertical" :key="'divider-' + index" />
                  </template>
                </span>
                <template slot="customPic" slot-scope="text, record">
                  <a-popover placement="right" trigger="click">
                    <template slot="content">
                      <img :src="getImgUrl(record.imgName, record.imgLarge)" width="500px" />
                    </template>
                    <div style="width:52px;height:52px;" v-if="record.imgName">
                      <img v-if="record.imgName" :src="getImgUrl(record.imgName, record.imgSmall)" class="item-img"
                        title="查看大图" />
                    </div>
                  </a-popover>
                </template>
              </a-table>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <!-- 新增/编辑区域 -->
      <add-process ref="addProccessRef" @ok="modalFormOk" @close="modalFormClose"></add-process>
      <begin-dialog ref="BeginDialogRef" @ok="BeginDialogOk"></begin-dialog>
      <bind-rule-list ref="bindRuleList" @update:codeRuleId="onCodeRuleIdUpdate" @ok="bindRuleListOk" @close="handleSubComponentClose"></bind-rule-list>
      <bind-trace-module-list ref="bindTraceModuleList" @ok="bindTraceModuleListOk" @update:traceTemplateId="onTraceTemplateIdUpdate" @close="handleTraceTemplateClose"></bind-trace-module-list>
      <event-trace-list ref="traceListRef" @ok="traceListOk" @close="closeTraceList"></event-trace-list>
      <process-dialog ref="processRef"></process-dialog>
    </div>
  </template>
  
  <script>
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import { queryEnableDictItemsByCode } from '@/api/identifierCode/identifierCode'
    import { getFileAccessHttpUrl } from '@/api/manage'
    import { getMpListShort } from '@/utils/util'
    import ProcessDialog from './modules/processDialog.vue'
    import AddProcess from './modules/addProcess.vue'
    import BeginDialog from './modules/beginDialog.vue'
    import BindRuleList from './modules/bindRuleList.vue'
    import EventTraceList from './modules/eventTraceList.vue'
    import BindTraceModuleList from './modules/bindTraceModuleList.vue'
    import { delProcess, getCraftByMaterialId, queryProcessByCraftId, getCookies, getTaskListBySearch, getTaskByDicType, getTaskList } from '@/api/api'
    export default {
      name: "list",
      mixins:[JeecgListMixin],
      components: {
        ProcessDialog,
        BeginDialog,
        AddProcess,
        BindRuleList,
        BindTraceModuleList,
        EventTraceList
      },
      data() {
        return {
          current: ['enterpriseRule'], // 顶部导航栏
          bindInfo:{},
          // 查询区域布局
          labelCol: {
            span: 5
          },
          wrapperCol: {
            span: 18,
            offset: 1
          },
  
          // 查询条件
          queryParam: {
            categoryType: '1',
            categoryId: '',
            materialParam: '',
            color: '',
            materialOther: '',
            weight: '',
            expiryNum: '',
            enabled: '',
            enableSerialNumber: '',
            enableBatchNumber: '',
            position: '',
            remark: '',
          },
          categoryTypeList: [],
          // categoryTypeList:[
          //   {
          //     code: 'JYZ',
          //     metarial:'绝缘子'
          //   },
          //   {
          //     code: 'BLP',
          //     metarial:'玻璃片'
          //   },
          // ],
          actionButtons: [],
          ipagination: {
            current: 1,
            pageSize: 10,
            pageSizeOptions: ['10', '20', '30'],
            showTotal: (total, range) => {
                return range[0] + '-' + range[1] + ' 共' + total + '条'
            },
            showQuickJumper: true,
            showSizeChanger: true,
            total: 0
          },
          categoryModelList: [],
          activeIndex: null, // 记录当前点击的标签索引
          activeModelIndex: null, // 新增：型号选中索引
          menuItems: [],
          dropdownStates: {},
          menuVisiable: false,
          dropdownVisible: false, // 控制下拉框的显示状态
          // 表头
          columns: [
            {
              title: '序号',
              dataIndex: '',
              key:'rowIndex',
              width: '50px',
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {title: '名称 ', dataIndex: 'materialName', align:"center",},
            {title: '编码 ', dataIndex: 'productNo', align:"center",},
            // {title: 'UDI名称 ', dataIndex: 'pName', align:"center",},
            {title: '型号 ', dataIndex: 'standard', align:"center",},
            {title: '类别 ', dataIndex: 'categoryName', align:"center",},
            // {title: '单位 ', dataIndex: 'unit', align:"center",},
            {title: '规格', dataIndex: 'model', align:"center",},
            // {title: '图片 ', dataIndex: 'pic', align:"center",scopedSlots: { customRender: 'customPic' } },
            {
              title: '操作',
              dataIndex: 'action',
              width: '30%',
              align:"center",
              scopedSlots: { customRender: 'action' },
            },
          ],
          dataSource: [],
          // 控制列的显示状态
          columnVisibility: {
            codeRuleId: false, // 设置为 false 隐藏该列
            formTemplateId: false, // 设置为 false 隐藏该列
            proceCode: false
          },
          url: {
            list: "", ///material/list
            delete: "/codeRules/fzRule/delete",
            deleteBatch: "/codeRules/fzRule/deleteBatch"
          },
          visibleRuleNode: false, // 规则节点抽屉开关
          uuid: '', // 每一项的uuid
          activeName: '',
          activeStandard: '',
          // 下拉框数据
          ruleSystem: [], // 发码机构
          ruleCategory: [], // 参考标准
          ruleLabel: [], // 类别
          getCookieId: null,
          getCookieCode: null
        }
      },
      computed: {
        // filteredColumns() {
        //   return this.columns.filter(column => {
        //     if (column.dataIndex in this.columnVisibility) {
        //       return this.columnVisibility[column.dataIndex];
        //     }
        //     return true;
        //   });
        // }
      },
      mounted() {
        // 根据字典类型获取一级字典信息
        this.getTaskByDicType()
        this.getCategoryList()
        // this.getCategoryModelList('JYZ','绝缘子', 0)
      },
      methods: {
        getImgUrl (imgName, type) {
          if (imgName && imgName.split(',')) {
            type = type ? type + '/' : ''
            return getFileAccessHttpUrl('systemConfig/static/' + type + imgName.split(',')[0])
          } else {
            return ''
          }
        },
        startTask(record){
          // this.menuVisiable = true
          console.log(record,'record===================')
          this.getCraftByMaterialId(record)
          // this.dropdownVisible = true // 设置下拉框为可见
          // 隐藏所有下拉菜单
          for (let key in this.dropdownStates) {
            this.dropdownStates[key] = false;
          }
          // 显示当前行的下拉菜单
          this.$set(this.dropdownStates, record.id, true);
        },
        // 根据字典类型获取一级字典信息
        async getTaskByDicType(){
          const res = await getTaskByDicType({type: 'TRACE_GOODS_CATEGORY',parentId: 0})
          if(  res.code == 200 && res.success == true ){
            this.categoryTypeList = res.result
            const firstId = res.result[0].id
            this.getCategoryModelList(firstId)
          } else {
            this.$message.warning(res.message)
          }
        },
        // 获取工艺列表
        async getCraftByMaterialId(record){
          this.menuItems = []
          const params = {
            materialId: record.id
          }
          const res = await getCraftByMaterialId(params)
          if(  res.code == 200 && res.success == true ){
            const resData = res.result
            this.menuItems = resData.map(item => ({
              id: item.id,
              craftName: item.craftName,
              craftCode: item.craftCode,
              subItems: []
            }))
          } else {
            this.$message.warning(res.message)
          }
        },
        // 获取产品规格
        async getCategoryModelList(id,code,i){
          const params = {
            type: 'TRACE_GOODS_CATEGORY',
            parentId: id
          }
          const res = await getTaskByDicType(params)
          if( res.code == 200 && res.success == true ){
            this.categoryModelList = res.result
          } else {
            this.$message.warning(res.message)
          }
        },
        // 搜索
        searchQuery(){
          const params = {
            materialName: this.queryParam.materialName,
            pageNo: this.ipagination.current,
            pageSize: this.ipagination.pageSize,
          }
          getTaskListBySearch(params).then(res => {
            if( res.code == 200 && res.success == true ){
              this.dataSource = res.result.records.map(record => {
              // 解析 workDetailVoList 并生成按钮数据
              const actionButtons = record.workDetailVoList.map(item => ({
                label: item.proceName, // 使用 proceName 作为按钮文本
                process: item, // 传递当前 process 数据
              }));
              return {
                ...record,
                actionButtons // 将生成的按钮数据存入 record
              };
            });
              this.ipagination.total = res.result.total
              this.$message({
                content: res.message,
                duration: 2,
                customClass: 'no-icon-message'
              })
            } else {
              this.$message({
                content: res.message,
                duration: 2,
                customClass: 'no-icon-message'
              })
            }
          })
        },
        // 重置
        searchReset(){
          this.queryParam.materialName = ''
          this.ipagination.current = 1
          const params = {
            pageNo: this.ipagination.current,
            pageSize: this.ipagination.pageSize
          }
          getTaskListBySearch(params).then(res => {
            if(res.code == 200 && res.success){
              this.dataSource = res.result.records.map(record => {
              // 解析 workDetailVoList 并生成按钮数据
              const actionButtons = record.workDetailVoList.map(item => ({
                label: item.proceName, // 使用 proceName 作为按钮文本
                process: item, // 传递当前 process 数据
              }));
              return {
                ...record,
                actionButtons // 将生成的按钮数据存入 record
              };
            });
              this.ipagination.total = res.result.total
              this.$message({
                content: res.message,
                duration: 2,
                customClass: 'no-icon-message'
              })
            }
          })
        },
        // 点击型号获取列表
        async getCategoryList(activeStandard, index){
          this.activeModelIndex = index; // 更新型号选中索引
          const params = {
            // materialName: this.activeName,
            materialName: '',
            pageNo: this.ipagination.current,
            pageSize: this.ipagination.pageSize,
            standard: activeStandard
          }
          const res = await getTaskListBySearch(params)
          if( res.code == 200 && res.success == true ){
            // this.dataSource = res.result.records
            this.dataSource = res.result.records.map(record => {
              // 解析 workDetailVoList 并生成按钮数据
              const actionButtons = record.workDetailVoList.map(item => ({
                label: item.proceName, // 使用 proceName 作为按钮文本
                process: item, // 传递当前 process 数据
              }));
              return {
                ...record,
                actionButtons // 将生成的按钮数据存入 record
              };
            });
            this.$message({
              content: res.message,
              duration: 2,
              customClass: 'no-icon-message'
            })
            this.ipagination.total = res.result.total; // 更新总条数
          }
        },
        // 点击分页获取列表
        handleTableChange(pagination, filters, sorter){
          this.ipagination = pagination;
          this.getCategoryList();
        },
        // 处理菜单项点击事件
        // handleMenuItemClick(item) {
        //   console.log('Selected item:', item)
        //   // 在这里处理菜单项点击后的逻辑
        //   // this.dropdownVisible = false // 关闭下拉框
        //   this.queryProcessByCraftId(item)
        // },
        // async queryProcessByCraftId(item){
        //   const params = {
        //     craftId: item.id,
        //     materialId: item.materialId
        //   }
        //   const res = await queryProcessByCraftId(params)
        //   if(  res.code == 200 && res.success == true ){
        //     console.log( res.result,' res.result====================')
        //     const resData = res.result
        //     if(resData.length == 0){
        //        this.$message.warning('该工艺下暂无生产流程，请先添加生产流程')
        //     } else {
        //       item.subItems = resData.map(subItem => ({
        //         codeRuleId: subItem.codeRuleId,
        //         processId: subItem.processId,
        //         proceName: subItem.proceName,
        //         craftId: subItem.craftId,
        //         seq: subItem.seq,
        //       }))
        //     }
            
        //   } else {
        //     this.$message.warning(res.message)
        //   }
        // },
        handleProcessClick(subItem, record){
          console.log(subItem,record,'subItem, record====================')
          // this.menuItems = []
          this.getCookie(subItem, record)
          // 隐藏弹框
          // this.$refs.BeginDialogRef.open(subItem, record)
          // this.dropdownVisible = false
        },
        // 查询是否有未完成订单
        async getCookie(subItem, record){
          const params = {
            materialId: record.materialId,
            processId: subItem.processId,
            craftId: subItem.craftId
          }
          const res = await getCookies(params)
          if( res.code == 200 && res.success == true ){
            if( res.result.id !== '' || res.result.id !== null || res.result.id !== undefined ){
              this.getCookieId = res.result.id
              this.getCookieCode = res.result.processCode
              this.$refs.BeginDialogRef.open(subItem, record, this.getCookieId, this.getCookieCode)
              this.dropdownVisible = false
            } else {
              this.getCookieId = null
              this.$refs.BeginDialogRef.open(subItem, record, this.getCookieId, this.getCookieCode)
              this.dropdownVisible = false
            }
          } else {
            this.$message.warning(res.message)
          }
        },
        // 重置
        // searchReset () {
        //   this.queryParam = {
            
        //   }
        //   this.loadData(1)
        // },
        // 
        modalFormOk(){
          this.loadData()
        },
        modalFormClose(){

        },
        bindRuleListOk(){

        },
        bindTraceModuleListOk(){

        },
        BeginDialogOk(){
          
        },
        handleAdd(){
          this.$refs.addProccessRef.add()
        },
        handleEdit(record){
            this.$refs.addProccessRef.edit(record)
        },
        chooseTemplateOk(){
          this.loadData()
        },
        onCodeRuleIdUpdate(newId){
            this.codeRuleId = newId;
            console.log('新的规则ID:', newId);
        },
        onTraceTemplateIdUpdate(newId){
            this.formTemplateId = newId;
            console.log('新的模版ID:', newId);
        },
        handleSubComponentClose() {
            this.loadData(); // 刷新父组件数据
        },
        handleTraceTemplateClose() {
            this.loadData(); // 刷新父组件数据
        },
        // 规则节点抽屉变化事件
        afterVisibleChange(val) {
          console.log('visible', val)
  
        },
        // 规则节点抽屉关闭 - 点击事件
        onClose() {
          this.visibleRuleNode = false;
        },
        begin(record){
            this.$refs.BeginDialogRef.open(record.codeRuleId)
            
        },
        // 删除
        async handleDelete(id){
          const res = await delProcess(id)
          if( res.code == 200 && res.success == true ){
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error('删除失败')
          }
        },
        // 查看详情
        getDetail(record){
          this.$refs.processRef.show(record)
        },
        closeTraceList(){},
        traceListOk(){ },
      },
      watch: {
        current() {
          this.queryParam.isStandard = this.current[0] === 'enterpriseRule' ? '1' : '0' // 规则查询参数
          this.loadData(1)
        }
      },
      created() {
        // 获取发码机构下拉框
        queryEnableDictItemsByCode({code: 'send_code_org'})
        .then(res => {
          this.ruleSystem = res
        })
        // 获取参考标准下拉框
        queryEnableDictItemsByCode({code: 'Reference_Standards'})
        .then(res => {
          this.ruleCategory = res
        })
        // 获取类别单选框
        queryEnableDictItemsByCode({code: 'rule_code_type'})
        .then(res => {
          this.ruleLabel = res
        })
      }
    }
  </script>
  
  <style lang='scss' scoped>
    .item-img {
      cursor: pointer;
      position: static;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .searchBox .table-page-search-wrapper {
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.1);
      border-radius: 5px;
      .ant-row {
        margin-bottom: 10px;
      }
      .ant-card a {
        color: #333;
        font-size: 16px;
      }
      .ant-card .label {
        font-size: 16px;
      }
      .ant-card a:hover {
        color: rgb(0, 0, 255);
      }
      .ant-card a.active {
        color: rgb(0, 0, 255);
      }
    }
    .metarialList {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
    }
    .metarialList .ant-list-item {
      flex: 1 1 calc(25% - 16px); /* 每行显示 4 项 */
      box-sizing: border-box;
    }
    /* 默认颜色 */
    .metarialList a {
      color: #333; /* 默认黑色 */
      text-decoration: none; /* 去掉下划线 */
      transition: color 0.3s; /* 添加颜色过渡效果 */
    }

    /* 鼠标悬停时的颜色 */
    .metarialList a:hover {
      color: blue; /* 悬停时变为蓝色 */
    }

    /* 点击后的颜色 */
    .metarialList a.active {
      color: blue; /* 点击后变为蓝色 */
    }
    .ant-table-row-cell-break-word span a {
      font-size: 22px;
      // color: #333;
    }
    .ant-table-row-cell-break-word span a:hover {
      border-bottom: 1px solid rgb(0, 0, 255);
    }
    // ::v-deep .ant-table {
    //   font-size: 16px !important;
    // }
    // .ant-table-tbody .ant-table-row td {
    //   font-size: 16px !important;
    // }
  </style>